/* eslint no-useless-concat: 0 */
/* eslint no-useless-concat: 0 */
/* eslint no-unused-vars: 0 */

import React, { Component } from "react";
import { withRouter, Redirect } from 'react-router-dom'
import PageTitle from "../../Theme/PageTitle";
import DashboardLayout from "../../Theme/DashboardLayout";
import { Modal } from "antd";
import GanttChartTimeline, {
  TimelineHeaders,
  SidebarHeader,
  TimelineMarkers,
} from 'react-calendar-timeline/lib' // new
// import 'react-calendar-timeline/lib/Timeline.css'
import containerResizeDetector from 'react-calendar-timeline/lib/resize-detector/container';
import './ScheduleView.scss'
import moment from 'moment-timezone'
import groupRendererPosted from '../utils/groupRendererPosted';
import generateGroups from './utils/generate-timeline/generateGroups';
import generateItems from './utils/generate-timeline/generateItems';
import Spinner from '../../Theme/Spinner';
import CustomPrimaryDateHeader from './CustomPrimaryDateHeader';
import CustomDateHeader from './CustomDateHeader';
import CustomHourlyHeader from './CustomHourlyHeader';
import DayMarkers from './DayMarkers';
import ItemModalDetails from './ItemModalDetails';

import { bindActionCreators } from "redux";
import * as postedScheduleActions from '../../../redux/actions/postedScheduleActions';  // TODO: remove dispatch / action from this component
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import getOffsetTime from '../../../utils/getOffsetTime';

const _ = require('lodash');

/**
 * Displays the one to two day schedule. When the component is first called it uses redux to call the api to get the
 * data from the database. It then calls generateItems and generateResources to correctly format the data it recieves from the api.
 * After the data has beeen formatted correctly it displays the information.
 */
class PostedScheduleView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      widescreen: false,
      resource: '',
      postedSchedule: '',
      resources: '',
      tours: '',
      startDate: '',
      scheduleFormat: '',
      itemModal: false,
      itemDetails: '',
      tourModalDisplay: '',
      backRedirect: ''
    };
    
  }


  componentDidMount = async () => {
    window.addEventListener("resize", this.resize.bind(this));
    this.resize();
    this.readyApiCall();
    this.customBrowserBackNavigation()
  }

  customBrowserBackNavigation = () => {
    // event handler for browser back button
    // Note: only works when AppRouter component wraps Switch w/ HashRouter
    window.onpopstate = () => {
      const { pathname } = this.props.history.location;
      if (pathname === '/posted-schedule-view-short') {
        this.setState({
          backRedirect: '/posted-schedules'
        });
      }
    }
  }

  readyApiCall = async () => {
    let resource = {
      id: this.props.resource.id || this.props.user.login.resourceId,
      name: this.props.resource.name || this.props.user.userDemographics.name
    }

    if (this.props.location.state) {  // redirected from PostedSchedulesPage with props
      const { startDate, scheduleFormat, postedId } = this.props.location.state;
      
      await this.props.actions.updatedPostedScheduleParameters({
        startDate,
        scheduleFormat,
        postedId,
        resourceId: resource.id,
        resourceName: resource.name
      })

      this.getDataFromApi(resource, startDate, scheduleFormat, postedId);

    } else { // on page refresh, pull postedSchedule from local storage
      let params = _.cloneDeep(this.props.postedScheduleParameters);

      const { startDate, scheduleFormat, postedId } = params;
      this.getDataFromApi(resource, startDate, scheduleFormat, postedId);
    }
  }

  getDataFromApi = async (resource, startDate, scheduleFormat, postedId) => {
    if (startDate.length>0){
      let tempDate = moment(startDate).format("MM/D/YYYY");
      startDate = tempDate;
    }
    await this.props.actions.fetchPostedSchedules(startDate, scheduleFormat, postedId, resource.id, resource.name).catch(error => {
      alert("Loading posted schedules failed" + JSON.stringify(error));
    });
    this.setState({
      postedSchedule: await this.props.postedSchedule,
    }, async () => {
      if (this.state.postedSchedule.resourceCollectionId) {
        // console.log(this.state.postedSchedule.resourceCollectionId);
        await this.props.actions.fetchResourceCollectionInformation({ resourceCollectionId: this.state.postedSchedule.resourceCollectionId }).catch(error => {
          console.log(error)
        });
      }

      this.setState({
        startDate: this.state.postedSchedule.startDate,
        scheduleFormat,
        tours: generateItems(this.state.postedSchedule.postedSchedule,null,this.state.postedSchedule.startDate),
        resources: generateGroups(this.state.postedSchedule.postedSchedule),
        resourceCollectionName: this.props.resourceCollectionInfo.name || ''
      });
    });
  }

  resize = () => {
    if (window.innerWidth >= 600) {
      this.setState({
        widescreen: true
      });
    } else {
      this.setState({
        widescreen: false
      });
    }
  }

  handleItemClick = async (item) => {
    const idx = await this.state.postedSchedule.postedSchedule.findIndex((elem) => {
      return elem.rId === item.group;
    });
    const resource = this.state.postedSchedule.postedSchedule[idx];
    this.setState({
      itemModal: true
    });
    let itemDetails;
    if (item.itemType === 'assignment') {
      const startTime = moment(item.start_time).format('h:mm a, MMM Do');
      const endTime = moment(item.end_time).format('h:mm a, MMM Do');
      const startTimeReal = moment(item.start_time_real).format('h:mm a, MMM Do');
      let assignment;
      if (item.backgroundColor === "#ffcc66") { // if assignment has a gold background color it must be on-call / stand by
        assignment = resource.dayTypes[item.rdtId] && resource.dayTypes[item.rdtId].tour && resource.dayTypes[item.rdtId].tour.assignments[item.id] ? resource.dayTypes[item.rdtId].tour.assignments[item.id] : resource.dayTypes[item.rdtId].assignment;
      } else assignment = resource.dayTypes[item.rdtId].tour.assignments[item.id];
      const { service, costObject, costObjectNumber,
        comment, description, requestNumber, myAssignmentComment, assignmentContract,overtimeReason } = assignment;
      itemDetails = {
        itemType: item.itemType,
        title: 'Assignment Details',
        description,
        comment,
        startTime,
        startTimeReal,
        endTime,
        service,
        costObject,
        costObjectNumber,
        requestNumber,
        myAssignmentComment,
        assignmentContract,
        overtimeReason
      };
    } else if (item.itemType === 'off-request') {
      // For day off requests that go over multiple days
      let tempId;
      if (typeof (item.id) === 'string' && item.id.includes('-') && item.itemType === 'off-request') {
        tempId = item.id.split('-')[0];
      } else tempId = item.id;
      const date = moment(item.start_time).format('M/D/YYYY');
      const { dayTypeName } = resource.dayTypes[item.id];
      const { dayOffRequestTitle, dayTypeComment, myDayTypeComment } = resource.dayTypes[item.id].dayOffRequest;
      itemDetails = {
        itemType: item.itemType,
        title: 'Day Type Request Details',
        dayOffRequestTitle,
        dayTypeName,
        dayType: "Day Off Request",
        date,
        dayTypeComment,
        myDayTypeComment
      };
    } else if (item.itemType === 'off-time') {
      const date = moment(item.start_time).format('M/D/YYYY');
      const { dayTypeName } = resource.dayTypes[item.id];
      const { abbreviation, dayTypeComment, myDayTypeComment, showCostObjectId,costCenter,wbse } = resource.dayTypes[item.id].dayOff;
      itemDetails = {
        itemType: item.itemType,
        title: 'Day Type Details',
        abbreviation,
        dayTypeName,
        date,
        dayTypeComment,
        myDayTypeComment,
        showCostObjectId,
        costCenter,
        wbse
      };
    } else if (
      item.itemType === 'tour'
      || item.itemType === 'overtime'
      || item.itemType === 'meal'
    ) {
      const { startTime, duration, remainDuration, meal, notificationComment, tourComment, myTourComment, tourContract, costCenter, wbse } = resource.dayTypes[item.rdtId].tour;
      const initialTourTime = moment.unix(startTime);
      const timeOffset = 0;//getOffsetTime(initialTourTime._d);
      const momentStartTime = moment(initialTourTime).add(timeOffset, 'minutes');
      const dayTypeTitle = resource.dayTypes[item.rdtId].title;
      const tourStartTime = momentStartTime.format('h:mm a, MMM Do');
      const actualDuration = momentStartTime.format('h:mma') === '12:00am' && remainDuration
        ? duration - remainDuration : duration;
      const tourEndTime = moment(tourStartTime, 'h:mm a, MMM Do').add(+actualDuration, 'hours').format('h:mm a, MMM Do');
      const mealStartTime = resource.dayTypes[item.rdtId].tour.meal ? moment.unix(meal.mealTime).add(timeOffset, 'minutes').format('h:mm a,  MMM Do') : 'N/A';
      const mealEndTime = resource.dayTypes[item.rdtId].tour.meal ? moment.unix(meal.mealEndTime).add(timeOffset, 'minutes').format('h:mm a, MMM Do') : 'N/A';
      itemDetails = {
        itemType: item.itemType,
        title: 'Tour Details',
        dayTypeTitle: dayTypeTitle ? dayTypeTitle : "N/A",
        tourStartTime,
        tourEndTime,
        mealStartTime,
        mealEndTime,
        notificationComment,
        tourComment,
        myTourComment,
        tourContract,
        costCenter,
        wbse
      };
    }
    this.setState({
      itemDetails
    });
  }

  handleModalCancel = (e) => {
    this.setState({
      itemModal: false,
    });
  }

  handleTimeChange = (visibleTimeStart, visibleTimeEnd, updateScrollCanvas) => {
    
    let startDateFixed = this.state.startDate;
    if (this.state && (this.state.startDate.length == 20 ||this.state.startDate.length == 25)) {
      startDateFixed = this.state.startDate.substring(0,10);
    }
    let minTime = moment(startDateFixed);
    let maxTime =0.0;
   
    if ( this.state == undefined) {
      console.log('visibleTime');
      
      updateScrollCanvas(visibleTimeStart, visibleTimeEnd);
      
    } else {
      if (this.state.scheduleFormat === 1 ) {
        maxTime = moment(startDateFixed).endOf('day');
      }
      else {
        maxTime = moment(startDateFixed).add(1, 'days').endOf('day');
      }
      
      if (visibleTimeStart < minTime && visibleTimeEnd > maxTime) {
        updateScrollCanvas(minTime, maxTime)
      } else if (visibleTimeStart < minTime) {
        updateScrollCanvas(minTime, minTime + (visibleTimeEnd - visibleTimeStart))
      } else if (visibleTimeEnd > maxTime) {
        updateScrollCanvas(maxTime - (visibleTimeEnd - visibleTimeStart), maxTime)
      } else {
        updateScrollCanvas(visibleTimeStart, visibleTimeEnd)
      }
    }
  }

  formatSubtitle = () => {
    moment.tz.setDefault("America/New_York");
    let startDate = moment(this.state.postedSchedule.startDate.substring(0,10)).format('MM/DD/YYYY') || null;
    let savedDate = moment(this.state.postedSchedule.savedDate.substring(0,19)).format('MM/DD/YYYY hh:mm a') || null;
    let userName = this.state.postedSchedule.userName || null;
    let resourceCollectionName = this.props.resourceCollectionInfo.name || null;
    moment.tz.setDefault("UTC");
  
    if(startDate && savedDate && userName && resourceCollectionName){
      return `Posting for ${resourceCollectionName} on ${startDate}. Posted on ${savedDate} by ${userName}`;
    }

    return '';
  }

  render() {

    if (this.state.backRedirect && !this.props.hamburgerMenu) {
      window.history.pushState(null, null, '#/schedules');
      return <Redirect to={this.state.backRedirect} />
    }

    if (this.state.resources && this.state.tours && window.innerWidth) {
      moment.tz.setDefault('UTC');

      let startDateFixed = this.state.startDate.substring(0,10);

      return (
        <DashboardLayout>
          <PageTitle title={'Posted Schedule'}

            subTitle={this.formatSubtitle()} />
          <GanttChartTimeline
            groups={this.state.resources}
            items={this.state.tours}
            defaultTimeStart={moment(startDateFixed)} // must use moment()
            defaultTimeEnd={this.state.scheduleFormat === 2 ? moment(startDateFixed).add(1, 'days').add(2, 'hours') : moment(startDateFixed).add(1, 'days')}
            onTimeChange={this.handleTimeChange}
            minZoom={this.state.scheduleFormat === 2 ? (60 * 60 * 26 * 1000) : (60 * 60 * 24 * 1000)}
            maxZoom={this.state.scheduleFormat === 2 ? (60 * 60 * 26 * 1000) : (60 * 60 * 24 * 1000)}
            groupRenderer={groupRendererPosted}
            sidebarWidth={120}  // leftSidebar: defaults to 150
            resizeDetector={containerResizeDetector} // prevents blank rightSideBar
            itemRenderer={({ item, timelineContext, itemContext, getItemProps, getResizeProps }) => {
              // console.log('item:', item);  // debug
              // console.log('itemContext:', itemContext);  // debug
              const { left: leftResizeProps, right: rightResizeProps } = getResizeProps();
              const backgroundColor = itemContext.selected ? (itemContext.dragging ? "red" : item.selectedBgColor) : item.backgroundColor;
              const borderColor = itemContext.resizing ? "red" : item.borderColor;


              return (
                <div
                  {...getItemProps({
                    style: {
                      backgroundColor: backgroundColor || "undefined",
                      color: item.color || "white",
                      borderColor: itemContext.selected ? "black" : borderColor || "",
                      borderStyle: item.borderStyle || "",
                      borderWidth: itemContext.selected ? 1 : 2,
                      borderRadius: 2,
                      borderLeftWidth: itemContext.selected ? 3 : 1,
                      borderRightWidth: itemContext.selected ? 3 : 1,
                    },
                    onMouseDown: () => {
                      console.log("on item click", item);
                    },
                    onMouseUp: () => {
                      this.handleItemClick(item);
                    },
                    onTouchStart: () => { // Used to select item in chrome mobile.
                      this.handleItemClick(item);
                    }
                  })}
                >
                  {itemContext.useResizeHandle ? <div {...leftResizeProps} /> : null}

                  <div
                    style={{
                      height: itemContext.dimensions.height,
                      overflow: "hidden",
                      paddingLeft: 3,
                      textOverflow: "string",
                      fontSize: 10,
                      whiteSpace: "nowrap",
                    }}
                  >
                    {itemContext.title}
                  </div>

                  {itemContext.useResizeHandle ? <div {...rightResizeProps} /> : null}
                </div>
              );
            }}
            stackItems={true}
            itemHeightRatio={1}
            canMove={false}
            canResize={false}
            fixedHeader={false}
          >
            <TimelineHeaders
              style={{
                position: "sticky",
                top: 0,
                zIndex: 100
              }}
            >
              <SidebarHeader>
                {({ getRootProps }) => {
                  return <div {...getRootProps()}>
                    {/* width must match sidebarWidth */}
                    <h6 style={{ width: 120 }} className="rct-dateHeader-primary">Resource</h6></div>
                }}
              </SidebarHeader>

              < CustomPrimaryDateHeader
                unit="day"
                textAlign="center"
                widescreen={this.state.widescreen}
              />
              < CustomDateHeader
                unit="day"
                textAlign="center"
                widescreen={this.state.widescreen}
              />

              {this.state.widescreen &&
                (
                  <CustomHourlyHeader />
                )
              }

            </TimelineHeaders>
            <TimelineMarkers>
              <DayMarkers startDate={this.state.startDate} />
            </TimelineMarkers>
          </GanttChartTimeline>

          <Modal
            zIndex={2000}
            title={this.state.itemDetails.title}
            visible={this.state.itemModal}
            onCancel={this.handleModalCancel} // the x in top right corner
            footer={[
              // <Button key="back" onClick={this.handleModalCancel}>Cancel</Button>,
              // <Button key="submit" type="submit" onClick={this.handleSearch}>
              //     Search
              // </Button>,
            ]}
          >
                <ItemModalDetails
                  itemDetails={this.state.itemDetails}
                  scheduleType={'postedSchedule'}
                  securityLevels={this.props.user.securityLevels}
                />

          </Modal>

        </DashboardLayout>
      )
    } else return <Spinner />
  }
}

PostedScheduleView.propTypes = {
  actions: PropTypes.object.isRequired,
  postedSchedule: PropTypes.object.isRequired,
  hamburgerMenu: PropTypes.bool.isRequired
};

function mapStateToProps(state) {
  return {
    postedSchedule: state.postedSchedules,
    resource: state.selectedResource,
    user: state.user,
    hamburgerMenu: state.navigation.hamburgerMenu,
    resourceCollectionInfo: state.resourceCollectionInformation,
    postedScheduleParameters: state.postedScheduleParameters,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: {
      fetchPostedSchedules: bindActionCreators(
        postedScheduleActions.fetchPostedSchedules,
        dispatch
      ),
      fetchResourceCollectionInformation: bindActionCreators(
        postedScheduleActions.fetchResourceCollectionInformation,
        dispatch
      ),
      updatedPostedScheduleParameters: bindActionCreators(
        postedScheduleActions.updatePostedScheduleParameters,
        dispatch
      ),
    }
  };
}

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps,
)(PostedScheduleView));



// WEBPACK FOOTER //
// ./src/Components/Schedule/OneTwoDay/PostedScheduleView.js